import React from 'react';
import Spinner from './Spinner';
import { observer } from 'mobx-react-lite';

const RedirectSpinner = observer(props => {
    return (
        <div className="redirect-loading-container" style={props.style !== undefined ? props.style : {}}>
            <Spinner />
        </div>
    )
})

export default RedirectSpinner